import { call, put } from "redux-saga/effects";

import { apiGeneral, queryBuilder, notify } from "services";
import { IPaginateRequest } from "interfaces/paginate-duck";
import { requestErrorHandler } from "utils";
import { PaginateCaveatTypesActions } from "store/ducks/settings/caveat-types";

export function* paginateCaveatTypesRequest(action: any) {
  try {
    const { query = {} } = action as IPaginateRequest;
    const queryString = queryBuilder(query);

    const { data: responseBody } = yield call(
      apiGeneral.get,
      `/indent-caveat-types?${queryString}`
    );

    const { caveatTypes, pagination } = responseBody;
    yield put(PaginateCaveatTypesActions.success(caveatTypes, pagination));
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(PaginateCaveatTypesActions.failure(errorMessage));
  }
}
